export default __webpack_public_path__ + "static/media/Odete Peixoto.59f39985.png";